import React, { useEffect, useState } from 'react';
import { api } from "../pages/api"; 
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const SalesChart = ({ dateRange, refreshKey, isFiltered }) => {
  const [salesData, setSalesData] = useState([]);

  useEffect(() => {
    const fetchSalesData = async () => {
      try {
        let res;
  
        const isValidFilter = isFiltered && dateRange.startDate && dateRange.endDate;
  
        if (isValidFilter && refreshKey === 0) {
          // Only POST if it's filtered and not a refresh
          res = await api.post(`/api/dash/generate-sales-summary`, {
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            location_id: "1",
            sale_type: "complete",
          });
        } else {
          // Use GET for default load or refresh
          res = await api.get(`/api/dash/daily-sales`);
        }
  
        const fetchedData = res.data.map(item => ({
          ...item,
          date: item.date,
          longDate: item.longdate,
        }));
  
        setSalesData(fetchedData);
      } catch (err) {
        console.error('Error fetching sales data:', err);
        setSalesData([]);
      }
    };
  
    fetchSalesData();
  }, [dateRange.endDate, dateRange.startDate, isFiltered, refreshKey]);

  if (!salesData.length) return <p>Loading...</p>;

  return (
    <div>
      <h4 style={{ textAlign: "center", marginBottom: "20px" }}>Sales Chart</h4>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={salesData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip formatter={(value, name, props) => [`${value}`, props.payload.longDate]} />
          <Legend />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#8884d8"
            strokeWidth={2}
            activeDot={{ r: 6 }}
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SalesChart;
